import React,{useEffect} from 'react'
import Cookies from 'js-cookie';
import axios from 'axios';
const Card = ({ title, value, bcolor }) => {
  const cardStyle = {
    backgroundColor: bcolor,
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'left',
  };

  const cardTitleStyle = {
    fontSize: '1.2em',
    margin: '0 0 8px 0',
    fontWeight: 'bold',
  };

  const cardValueStyle = {
    fontSize: '0.9em',
    margin: '0',
  };

  return (
    <div style={cardStyle}>
      <h3 style={cardTitleStyle}>{title}</h3>
      <p style={cardValueStyle}>{value}</p>
    </div>
  );
};


const DashboardAnalytics = () => {
  const metrics = [
    { title: 'Assigned Essays', value: '10', bcolor: '#DFF5E9' },
    { title: 'Essays(In Progress)', value: '6', bcolor: '#F5ECED' },
    { title: 'Essays(Checked)', value: '4', bcolor: '#FFF8EB' },
  ];

  useEffect(() => {
    // Fetch profile data from the API
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(`https://backend.writerswright.com/api/v1/student/getStudentProfile?Id=${Cookies.get('id')}`);
        Cookies.set('studentId', response.data.Id)
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();
  }, []);
  return (
    <div>
      <h4 className="title">
        Analytics
      </h4>
      <div style={gridStyle}>
        {metrics.map((metric, index) => (
          <Card key={index} title={metric.title} value={metric.value} bcolor={metric.bcolor} />
        ))}
      </div>
    </div>
  )
}
const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: '16px',
  padding: '16px 52px',
};


export default DashboardAnalytics
